import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import FileInput from 'assets/components/inputs/file/FileInput';
import ThemeFileInputDropzone from 'assets/components/inputs/file/themes/Theme.FileInput.Dropzone';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import MimeType from 'assets/utils/file/mimeType/MimeType';
import { HttpStatus } from 'config/Api.Config';
import { first } from 'lodash';
import accountReceivableImportFromExcelApi from 'models/finance/accountReceivable/importFromExcel/Api.AccountReceivable.ImportFromExcel';
import React from 'react';
import { useAccountReceivableProvider } from '../Finance.AccountReceivable.Hooks';

type ImportExcelFile = Omit<Api.Finance.AccountReceivable.ImportFromExcel.IRequest, 'file'> & {
  file: Hooks.Input.File.Info;
};

const FinanceAccountReceivableImport: React.FC = () => {
  const { lang } = getLocales();
  const { pageRouter, listApi } = useAccountReceivableProvider();

  return (
    <ModalForm<ImportExcelFile>
      subcomponents={ThemeModalFormDefault}
      title={lang.accountReceivableImportExcel}
      onCancel={pageRouter.updateParams}
      onSubmit={async ({ file }) => {
        const res = await accountReceivableImportFromExcelApi({ formFile: file.original });

        if (res.status !== HttpStatus.ok) addLog({ error: res.message });
        else addLog({ success: lang.importSuccess });

        listApi.execute((body) => body);
        pageRouter.updateParams();
      }}
      render={({ form }) => (
        <FormWrapper>
          <FileInput
            name="file"
            allowedMimeTypes={[MimeType.appMS_EXCEL, MimeType.appOPEN_XML_SHEET]}
            label={lang.accountReceivableImportExcel}
            fileLimit={1}
            value={form.data?.file ? [form.data.file] : []}
            onChange={({ file }) => form.update({ file: first(file) })}
            class={ThemeFileInputDropzone}
          />
        </FormWrapper>
      )}
    />
  );
};

export default FinanceAccountReceivableImport;
